module.exports = __webpack_public_path__ + "img/under-block.ed994bbe.png";